import { Edit } from "@mui/icons-material";
import { RequestError, useApi } from "../../services";
import { useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Snackbar, TextField } from "@mui/material";

export const ChangeUserPassBtn: React.FC = () => {
  const api = useApi();

  const [open, setOpen] = useState(false);
  const [error, setError] = useState<RequestError | undefined>(undefined);

  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formJson = Object.fromEntries((formData as any).entries());
    const oldPassw = formJson.oldPassw;
    const newPassw = formJson.newPassw;

    api.user.changePassw(oldPassw, newPassw).then((data) => {
      if ("error" in data) {
        setError(data);
        return;
      }

      if (data.ok) {
        handleCloseModal();
      } else {
        setError({
          "error": "Erro",
          "message": "Problemas ao atualizar a senha do usuário, confira se a senha antiga está correta",
        });
      }
    });
  };
  const handleCloseAlert = () => {
    setError(undefined);
  };

  return <>
    {
      error &&
      <Snackbar
        open={error !== null}
        autoHideDuration={4500}
        onClose={handleCloseAlert}
        message="Note archived"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: "100%" }}>
          {error.error + ":" + error.message}
        </Alert>
      </Snackbar>
    }

    <Dialog
      open={open}
      onClose={handleCloseModal}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
      }}
    >
      <DialogTitle>Alterar Senha</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Para alterar a senha basta digitar a senha antiga e a nova senha
        </DialogContentText>
        <TextField
          autoFocus
          required
          fullWidth
          margin="dense"
          id="oldPassw"
          name="oldPassw"
          label="Senha Antiga"
          type="password"
          variant="standard"
        />
        <TextField
          required
          fullWidth
          margin="dense"
          id="newPassw"
          name="newPassw"
          label="Nova Senha"
          type="password"
          variant="standard"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModal} variant="contained">Cancelar</Button>
        <Button type="submit" variant="outlined">Alterar</Button>
      </DialogActions>
    </Dialog>

    <IconButton onClick={handleOpenModal}>
      <Edit />
    </IconButton>
  </>;

};